import { useBootstrap } from "components/store/source";

export const useHidePIIInfo = () => {
  const {
    featureFlags: { hidePIIInfo },
  } = useBootstrap();

  return hidePIIInfo ?? false;
};
